module.exports = __webpack_public_path__ + "img/french-fries.31eb0ba7.svg";